import { useMemo } from "react";

// the query string for you.
export function useEmbeddedHelper() {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      isEmbedded:
        params.get("embed") === "1" &&
        window.location !== window.parent?.location,
      postCloseMessage: () => {
        window.parent?.postMessage(
          {
            type: "intractive.close",
          },
          "*"
        );
      },
    };
  }, []);
}
